<script setup>
import { storeToRefs } from "pinia";

import { useNotifyStore } from "@Store/overhauling/useNotifyStore";

const notifyStore = useNotifyStore();
const { notifications } = storeToRefs(notifyStore);
</script>

<template>
  <div class="notify-container _notify_container">
    <TransitionGroup name="notify">
      <Component
        :is="notify.component"
        v-for="notify in notifications"
        :key="notify.id"
        :notify="notify"
      />
    </TransitionGroup>
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;

.notify-container {
  position: fixed;
  top: spacing.$xxxxs;
  right: spacing.$xxxxs;
  z-index: 1000;
  padding-left: spacing.$xxxxs;
}

.notify-enter-active,
.notify-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(1, 0.01, 0.66, 1);
}

.notify-enter,
.notify-leave-active {
  opacity: 0;
}
</style>
